"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { key: 0 };
const _hoisted_2 = /*#__PURE__*/ (0, vue_2.createTextVNode)(" You’re on a roll. Do you want to skip to harder questions? ");
const _hoisted_3 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "prose mb-5" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("p", null, "This won’t impact your score level.")
], -1);
const _hoisted_4 = ["onClick"];
const _hoisted_5 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "Skip Section", -1);
const _hoisted_6 = ["onClick"];
const _hoisted_7 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "I’ll keep going", -1);
const pinia_1 = require("pinia");
const ProficiencyTestQuestion_vue_1 = __importDefault(require("./ProficiencyTestQuestion.vue"));
const TeleportModal_vue_1 = __importDefault(require("../modals/TeleportModal.vue"));
const ButtonIcon_vue_1 = __importDefault(require("../ButtonIcon.vue"));
const ProficiencyTest_1 = require("../../stores/ProficiencyTest");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ProficiencyTestSection',
    props: {
        section: {
            type: Object,
            required: true,
        },
        lastSection: {
            type: Boolean,
            default: false,
        },
    },
    setup(__props) {
        const props = __props;
        const store = (0, ProficiencyTest_1.useProficiencyTestStore)();
        const { currentQuestionIndex, showSkipModal } = (0, pinia_1.storeToRefs)(store);
        function keepGoing() {
            showSkipModal.value = false;
            store.nextQuestion();
        }
        function skipToNextSection() {
            showSkipModal.value = false;
            store.skipToNextSection();
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (props.section)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(props.section.questions, (question, index) => {
                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                                (index === (0, vue_2.unref)(currentQuestionIndex))
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ProficiencyTestQuestion_vue_1.default, {
                                        key: 0,
                                        question: question
                                    }, null, 8, ["question"]))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ], 64));
                        }), 256))
                    ]))
                    : (0, vue_2.createCommentVNode)("", true),
                ((0, vue_2.unref)(showSkipModal))
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(TeleportModal_vue_1.default, {
                        key: 1,
                        onClose: _cache[0] || (_cache[0] = ($event) => (showSkipModal.value = false))
                    }, {
                        header: (0, vue_2.withCtx)(() => [
                            _hoisted_2
                        ]),
                        default: (0, vue_2.withCtx)(() => [
                            _hoisted_3,
                            (0, vue_2.createElementVNode)("div", null, [
                                (0, vue_2.createElementVNode)("button", {
                                    class: "button button-outlined button-mutedpurple-800 mr-5 has-icon",
                                    type: "button",
                                    onClick: (0, vue_2.withModifiers)(skipToNextSection, ["prevent"])
                                }, [
                                    (0, vue_2.createVNode)(ButtonIcon_vue_1.default),
                                    _hoisted_5
                                ], 8, _hoisted_4),
                                (0, vue_2.createElementVNode)("button", {
                                    class: "button button-outlined button-mutedpurple-800 has-icon",
                                    type: "button",
                                    onClick: (0, vue_2.withModifiers)(keepGoing, ["prevent"])
                                }, [
                                    (0, vue_2.createVNode)(ButtonIcon_vue_1.default),
                                    _hoisted_7
                                ], 8, _hoisted_6)
                            ])
                        ]),
                        _: 1
                    }))
                    : (0, vue_2.createCommentVNode)("", true)
            ], 64));
        };
    }
});
